import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Modal, Text } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';

const SmartFieldsConfirmModal = ({ isOpen, onConfirm, onCancel }) => {
    const { t } = useWeb5Context();

    return (
        <Modal
            isOpen={isOpen}
            title={t('label_sf_advice_remove_dinamic_fields_title')}
            onRequestClose={onCancel}
            onCancel={onCancel}
            onConfirm={onConfirm}
            confirmText={t('action_accept')}
            cancelText={t('action_cancel')}
            size="small"
        >
            <Text>{t('label_sf_advice_remove_dinamic_fields_desc')}</Text>
        </Modal>
    );
};

SmartFieldsConfirmModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default memo(SmartFieldsConfirmModal);
